import React from "react";
import { browserHistory } from "react-router";
import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableRowColumn
} from "material-ui/Table";
import { PersianDate } from "../../helpers/utility";
import * as MabnaButton from "../common/Button/Button";
import * as qs from "qs";

const styles = {
  table: {
    width: "100%",
    fontFamily: "IranYekanRegular",
    direction: "rtl"
  },
  tableHeaderColumn: {
    textAlign: "right"
  },
  tableRowColumn: {
    textAlign: "right"
  }
};

const tableClassPrefix = "mabna-table";
const defaultTableProps = {
  table: {
    multiSelectable: false,
    selectable: false,
    className: tableClassPrefix
  },
  tableHeaders: {
    displayRowCheckbox: false,
    adjustForCheckbox: false,
    displaySelectAll: false,
    className: tableClassPrefix + "-headers"
  },
  tableBody: {
    displayRowCheckbox: false,
    className: tableClassPrefix + "-body"
  },
  tableRows: {
    selectable: false,
    className: tableClassPrefix + "-row"
  }
};

const emptyListMessage = "موردی یافت نشد";

const finishedHostingSetup = item => item.finished_hosts_setup;

export const goToEvent = eventId =>
  browserHistory.push(`/dashboard/supervisor/events/${eventId}`);

export const goToUploadEventDocuments = eventId =>
  browserHistory.push(`/dashboard/supervisor/events/${eventId}/documents`);

export const goToEventCouponCodes = eventId =>
  browserHistory.push(`/dashboard/supervisor/events/${eventId}/coupons`);

export const goToEditCouponCode = (eventId, couponId) =>
  browserHistory.push(
    `/dashboard/supervisor/events/${eventId}/coupons/${couponId}`
  );

export const goToEventStudents = (eventId, params = {}) =>
  browserHistory.push(
    `/dashboard/supervisor/events/${eventId}/students/?${qs.stringify(params)}`
  );

export const goToSchoolEventStudents = (eventId, schoolId) =>
  browserHistory.push(
    `/dashboard/supervisor/events/${eventId}/schools/${schoolId}/students`
  );

export const goToEventSchools = eventId =>
  browserHistory.push(`/dashboard/supervisor/events/${eventId}/schools`);

export const goToEventHosts = eventId =>
  browserHistory.push(`/dashboard/supervisor/events/${eventId}/hosts`);

export const goToHost = (eventId, hostId) =>
  browserHistory.push(
    `/dashboard/supervisor/events/${eventId}/hosts/${hostId}`
  );

export const goToAddHost = eventId =>
  browserHistory.push(`/dashboard/supervisor/events/${eventId}/hosts/add`);

const studentsListButton = eventId => (
  <MabnaButton.Primary
    key={`s-${eventId}`}
    outline
    onClick={() => goToEvent(eventId)}
  >
    لیست دانش‌آموزان
  </MabnaButton.Primary>
);

const hostingButton = eventId => (
  <MabnaButton.Primary
    key={`h-${eventId}`}
    onClick={() => goToEventHosts(eventId)}
  >
    حوزه بندی
  </MabnaButton.Primary>
);

const managementButton = eventId => (
  <MabnaButton.Primary
    key={`m-${eventId}`}
    onClick={() => goToUploadEventDocuments(eventId)}
  >
    مدیریت
  </MabnaButton.Primary>
);

const renderButtons = (finished, eventId) => [
  studentsListButton(eventId),
  finished ? managementButton(eventId) : hostingButton(eventId)
];

const eventStatusRenderer = finished => {
  return finished ? "پایان‌یافته" : "در حال حوزه‌بندی";
};

const renderTableHeaders = (headers, props = {}) => {
  const { tableHeaders, tableRows } = props;

  return (
    <TableHeader {...tableHeaders}>
      <TableRow {...tableRows}>
        {headers.map((h, i) => (
          <TableHeaderColumn key={i} style={styles.tableHeaderColumn}>
            {h}
          </TableHeaderColumn>
        ))}
      </TableRow>
    </TableHeader>
  );
};

const renderTableRow = (item, index) => {
  return (
    <TableRow hoverable={false} selectable={false} key={index}>
      <TableRowColumn style={styles.tableRowColumn}>
        {item.title}
      </TableRowColumn>

      <TableRowColumn style={styles.tableRowColumn}>
        <DateFromTo from={item.event_date} to={item.event_end_date} />
      </TableRowColumn>

      <TableRowColumn style={styles.tableRowColumn}>
        {eventStatusRenderer(finishedHostingSetup(item))}
      </TableRowColumn>
      <TableRowColumn style={styles.tableRowColumn}>
        {renderButtons(item.finished_hosts_setup, item.id)}
      </TableRowColumn>
    </TableRow>
  );
};

const renderTable = items => {
  const { tableHeaders, tableRows } = defaultTableProps;

  return (
    <Table style={styles.table} selectable={false} multiSelectable={false}>
      {renderTableHeaders(["عنوان", "تاریخ", "وضعیت", ""], {
        tableHeaders,
        tableRows
      })}
      <TableBody showRowHover={true} displayRowCheckbox={false}>
        {items.map(renderTableRow)}
      </TableBody>
    </Table>
  );
};

const DateFromTo = ({ from, to }) => (
  <div>
    <PersianDate>{from}</PersianDate>

    {to && (
      <span>
        <span> الی </span>
        <PersianDate>{to}</PersianDate>
      </span>
    )}
  </div>
);

export const eventsTableRenderer = items => {
  if (items.length === 0) return <div>{emptyListMessage}</div>;

  return renderTable(items);
};

const functionType = typeof (i => 0);

const rowObjectToArray = (obj, columns) => {
  const cellRenderer = cellData =>
    typeof cellData === functionType ? cellData(obj) : obj[cellData];
  // typeof cellData === typeof {} && cellData.hasOwnProperty('renderer')
  //   ? cellData.renderer(obj)
  //   : obj[cellData]

  // c => obj[c] && obj[c].renderer ? obj[c].renderer : obj[c]
  return columns.map(cellRenderer);
};

const renderGeneralTableRow = (item, index, props = {}) => {
  return (
    <TableRow key={index} {...props}>
      {item.map((data, column) => (
        <TableRowColumn key={column} style={styles.tableRowColumn}>
          {data}
        </TableRowColumn>
      ))}
    </TableRow>
  );
};

const renderGeneralTable = (items, headers, columns, props = {}) => {
  const { table, tableHeaders, tableBody, tableRows } = props;

  let selectableKey = "selectable";

  if (tableRows.hasOwnProperty("selectableKey")) {
    selectableKey = tableRows.selectableKey;
    delete tableRows.selectableKey;
  }

  return (
    <Table style={styles.table} {...table}>
      {renderTableHeaders(headers, { tableHeaders, tableRows })}
      <TableBody {...tableBody}>
        {items.map((rowData, index) => {
          const selectable = !!rowData[selectableKey];
          const className =
            tableRows.className + (selectable ? "" : " disabled");
          const newTableRows = { ...tableRows, selectable, className };

          return renderGeneralTableRow(
            rowObjectToArray(rowData, columns),
            index,
            newTableRows
          );
        })}
      </TableBody>
    </Table>
  );
};

export const generalTableRenderer = (
  items,
  headers,
  columns,
  props = defaultTableProps
) => {
  if (items.length === 0) return <div>{emptyListMessage}</div>;

  return renderGeneralTable(items, headers, columns, props);
};

export const buttonRenderer = (props = {}) => {
  return <MabnaButton.Primary {...props}>{props.label}</MabnaButton.Primary>;
};



// WEBPACK FOOTER //
// ./src/components/supervisor/helpers.js